// @generated by protoc-gen-es v1.10.0
// @generated from file fingertip/common/type/v1/store_order.proto (package fingertip.common.type.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { StoreOrderStatus } from "../../enum/v1/store_order_status_pb.js";

/**
 * @generated from message fingertip.common.type.v1.StoreOrder
 */
export const StoreOrder = /*@__PURE__*/ proto3.makeMessageType(
  "fingertip.common.type.v1.StoreOrder",
  () => [
    { no: 1, name: "id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "order_number", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "site_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 4, name: "status", kind: "enum", T: proto3.getEnumType(StoreOrderStatus) },
    { no: 5, name: "total_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "total_application_fee_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "currency", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 8, name: "total_tax_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 9, name: "site_contact_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 10, name: "coupon_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 11, name: "comments", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 12, name: "notes", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 13, name: "payment_marked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 14, name: "cart_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 17, name: "payment_method_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 18, name: "test", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 19, name: "draft", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 20, name: "canceled_at", kind: "message", T: Timestamp },
    { no: 21, name: "created_at", kind: "message", T: Timestamp },
    { no: 22, name: "updated_at", kind: "message", T: Timestamp },
    { no: 23, name: "completed_at", kind: "message", T: Timestamp },
    { no: 24, name: "price_includes_tax", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 25, name: "contact_email", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 26, name: "billing_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 27, name: "shipping_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 28, name: "delivery_marked", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 29, name: "requires_shipping", kind: "scalar", T: 8 /* ScalarType.BOOL */ },
    { no: 30, name: "shipping_rate_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 31, name: "shipping_price_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 32, name: "shipping_tax_in_cents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

